import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import Marquee from '@components/Marquee/Marquee'

import { logos } from '@static/vectors/logos'
import './Partners.css'

const logosEntries = Object.entries(logos)
const logosList = logosEntries.map(([key, logo]) => (
  <article className="logo-wrapper" key={`slide-${key}`}>
    <img src={logo} alt={`logo ${key}`} />
  </article>
))

export default function Partners() {
  return (
    <section id="partners" className="landing-section">
      <div className="container">
        <h1>
          <MarkdownMessage id="home.partners.title" />
        </h1>
        <p>
          <FormattedMessage id="home.partners.text" />
        </p>
        <a
          className="button"
          target="_blank"
          href="https://legal.adigital.org/datalab/manifiesto/"
          rel="noreferrer"
        >
          <span>
            <FormattedMessage id="know-more" />
          </span>
          <span className="icon icon-arrow" />
        </a>
      </div>
      <Marquee duration={logosEntries.length * 3}>{logosList}</Marquee>
    </section>
  )
}
